import {AllUserTypeList} from "./User.type";
import {KeywordType, KeywordTypeList} from "./Keyword.type";
import {SearchFormProps} from "../../common/searchForm/SearchForm.props";
import {OptionType} from "../../common/searchForm/constants/Option.type";

export const UserSearchFormProps: SearchFormProps = {
    options: [
        {
            type: OptionType.CHECK_LIST,
            name: "분류",
            key: "type",
            list: AllUserTypeList.map(userType => userType.type),
            stringList: AllUserTypeList.map(userType => userType.name),
            value: [true, true, true]
        },
        {
            type: OptionType.TYPE_TEXT,
            name: "검색",
            key: "keyword",
            list: KeywordTypeList.map(keywordType => keywordType.type),
            stringList: KeywordTypeList.map(keywordType => keywordType.name),
            value: {
                type: KeywordType.NAME,
                text: ""
            }
        }
    ],
    onSearch: () => {},
    onUpdate: () => {}
}